import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { PayslipCard } from "../features/hr/PayslipCard";
import { AdvanceCard } from "../features/hr/AdvanceCard";
import { SalaryAckCard } from "../features/payroll/SalaryAckCard";
import { MyHoldBanner } from "../features/payroll/MyHoldBanner";

export default function MyPayslipPage() {
  const { t } = useTranslation();
  const [month] = useState(new Date().toISOString().slice(0, 7));

  return (
    <AppShell title={t("nav.myPayslip")} subtitle={t("payslip.subtitle")}>
      <div className="grid gap-6" data-testid="my-payslip-page">
        <MyHoldBanner />
        <SalaryAckCard month={month} />
        <PayslipCard />
        <AdvanceCard />
      </div>
    </AppShell>
  );
}
